var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.337,
    height: 29.536,
    viewBox: "0 0 29.337 29.536",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-17.39 -529.39)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.815,537.321c.459-4.15,9.624-2.075,7.715-7.463-.293-.824-1.613-.469-1.319.362.839,2.362-2.344,2.651-3.964,3.192-1.947.651-3.556,1.738-3.8,3.909C24.354,538.2,25.72,538.186,25.815,537.321Z",
    transform: "translate(5.533 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.623,533.816c-1.788.421-3.422,1.187-3.979,3.065a.683.683,0,0,0,1.317.362c.616-2.073,3.34-2.109,5.08-2.614a3.312,3.312,0,0,0,2.682-3.825c-.111-.86-1.477-.871-1.365,0C34.667,533.208,32.457,533.382,30.623,533.816Z",
    transform: "translate(7.232 0.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.444,548.231c5.042-.194,7.283-2.407,7.283-5.115,0-2.35-1.693-4.328-5.444-4.937.018-.874.02-1.716.02-2.505H34.529v3.665h2.35a.624.624,0,0,1,.623.623v5.618a.624.624,0,0,1-.623.623H31.933a.626.626,0,0,1-.624-.623v-5.618a.626.626,0,0,1,.624-.623h2l0-3.665H17.39c0,5.149.005,12.63,4.807,16.2-2.914.214-4.807.557-4.807.942,0,.651,5.353,1.179,11.956,1.179S41.3,553.47,41.3,552.818c0-.385-1.893-.728-4.807-.942A9.788,9.788,0,0,0,39.444,548.231Zm1.763-7.761c2.4.469,2.824,1.463,2.8,2.751-.03,1.461-.532,2.451-3.8,2.792A22.879,22.879,0,0,0,41.207,540.47Z",
    transform: "translate(0 4.928)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTe);
export default __webpack_public_path__ + "static/media/iconTe.f47dee9fa7b91f5d98d5c39bbda3a945.svg";
export { ForwardRef as ReactComponent };